/* import __COLOCATED_TEMPLATE__ from './ticket-type-mapping.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();